import styled from 'styled-components';
import { components } from 'react-select';
import Select from '#/shared/components/Select';
import { DESKTOP_MIN_BREAK } from '#/shared/constants';
import { focusStyle } from '#/shared/css/focus';
import TranslateIconBase from '#/shared/components/GeneratedIcons/trimet/Translate';

export const CustomOption = styled(components.Option)`
  border: solid red 3px;
`;

export const LanguageButtonWrapper = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: end;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    margin-top: -1px;
  }
`;

export const LanguageButtonInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.primaryFontColorReverse};
  height: 100%;
  min-height: 1rem;
  font-size: 1.2rem;
}`;

export const LanguageRef = styled.div`
  display: flex;
`;

export const LanguageButtonIcon = styled(TranslateIconBase).attrs(props => ({
  fill: props.theme.primaryFontColorReverse,
  viewBox: '0 0 390 390',
}))`
  margin: 0 0 -2px 0;
  width: 28px;
  height: 28px;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    margin: 0 0.25em -2px 0;
    width: 22px;
    height: 22px;
  }
`;

export const LanguageSelect = styled(Select)`
  background-color: transparent;
  display: flex;
  flex: 1;
  height: 100%;

  div[class*='language__menu'] {
    overflow: hidden;
    width: auto;
    min-width: 8.5rem;
    z-index: 13;
    top: 43px;
    right: 0;

    div[class*='language__menu-list'] {
      .language__option--is-disabled {
        background-color: ${props => props.theme.selectedLanguageDropdownColor};
        color: ${props => props.theme.mainColor} !important;
        cursor: default !important;
        display: flex;
        justify-content: space-between;
      }
      .language__option--is-focused {
        background-color: ${props => props.theme.focusedLanguageDropdownColor};
      }
      padding: 0;
      transform: initial;
      top: initial;
      text-align: left;
      overflow: auto;
      max-height: 70vh;
      div[class*='option'] {
        color: ${props => props.theme.mainColor};
        font-size: 15px;
        @media (any-hover: hover) {
          &:hover {
            cursor: pointer;
          }
        }
      }
      @media (orientation: landscape) and (max-height: 430px) {
        max-height: ${props => (props.alertBannerIsVisible ? '30vh' : '50vh')};
      }
    }
    @media (max-width: ${DESKTOP_MIN_BREAK}) {
      width: auto;
      min-width: unset;
    }
  }
  div.language__indicators {
    display: none;
  }
  div.language__value-container {
    display: flex;
    flex-wrap: nowrap;
    padding: 0 0.75em;
  }
  div.language__single-value {
    overflow: visible;
  }
  div.language__control {
    border-radius: 0;
    background-color: transparent;
    box-shadow: none;
    border: none;

    @media (any-hover: hover) {
      &:hover {
        background-color: ${props => props.theme.navBackgroundHover};
        cursor: pointer;
      }
    }
  }
  div.language__control--is-focused {
    ${focusStyle({ type: 'inset', important: true })}

    background-color: ${props => props.theme.navBackgroundHover};
  }
`;
